/**
 * EmblemInfoModal Component
 * Modal with information about Emblem
 */

import { useState } from 'react';
import { Modal } from '../shared/Modal';
import { InfoButton } from '../shared/InfoButton';
import { designTokens } from '../../constants/designTokens';
import { useBrand } from '../../contexts/BrandContext';
import { useLanguage } from '../../i18n';

export function EmblemInfoModal() {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useLanguage();
  const brand = useBrand();
  const productName = brand?.productName || t('common.productFallback');

  return (
    <>
      <div className="emblem-info-trigger" onClick={() => setIsOpen(true)}>
        <InfoButton 
          onClick={() => setIsOpen(true)} 
          ariaLabel={t('emblem.info.ariaLabel')}
        />
        <span className="emblem-info-text">{t('emblem.info.trigger')}</span>
      </div>

      <Modal 
        isOpen={isOpen} 
        onClose={() => setIsOpen(false)}
        title={t('emblem.info.title')}
      >
        <div className="emblem-modal-content">
          <p>
            {t('emblem.info.paragraph1')}
          </p>
          <p>
            {t('emblem.info.paragraph2', { productName })}
          </p>
          <a 
            href="https://emblemapp.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="emblem-link"
          >
            {t('emblem.info.linkLabel')}
          </a>
        </div>
      </Modal>

      <style>{`
        .emblem-info-trigger {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: ${designTokens.spacing.sm};
          cursor: pointer;
          user-select: none;
        }

        .emblem-info-text {
          color: ${designTokens.colors.text.secondary};
          font-size: ${designTokens.typography.fontSize.sm};
          transition: color 0.2s ease;
          cursor: pointer;
        }

        .emblem-info-trigger:hover .emblem-info-text {
          color: ${designTokens.colors.brand.primary};
        }

        .emblem-modal-content {
          color: ${designTokens.colors.text.primary};
          line-height: 1.6;
          text-align: left;
        }

        .emblem-modal-content p {
          margin: 0 0 ${designTokens.spacing.md} 0;
          font-size: ${designTokens.typography.fontSize.base};
        }

        .emblem-modal-content p:last-of-type {
          margin-bottom: ${designTokens.spacing.lg};
        }

        .emblem-link {
          display: inline-block;
          color: ${designTokens.colors.brand.primary};
          text-decoration: none;
          font-weight: ${designTokens.typography.fontWeight.medium};
          transition: opacity 0.2s ease;
        }

        .emblem-link:hover {
          opacity: 0.8;
          text-decoration: underline;
        }

        ${designTokens.media.mobile} {
          .emblem-info-text {
            font-size: ${designTokens.typography.fontSize.xs};
          }

          .emblem-modal-content p {
            font-size: ${designTokens.typography.fontSize.sm};
          }
        }

        /* iPhone SE and small mobile devices - Fix button overlap */
        @media (max-width: 375px) and (max-height: 667px) {
          .emblem-info-trigger {
            margin-top: -20px;
          }
        }
      `}</style>
    </>
  );
}
